import { render, staticRenderFns } from "./yearInReview.vue?vue&type=template&id=560eae0e&scoped=true&"
import script from "./yearInReview.vue?vue&type=script&lang=js&"
export * from "./yearInReview.vue?vue&type=script&lang=js&"
import style0 from "./yearInReview.vue?vue&type=style&index=0&id=560eae0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560eae0e",
  null
  
)

export default component.exports